<template>
  <v-form class="d-flex flex-column align-center pt-12" @submit.prevent="submit">
    <v-alert color="primary" dark v-model="alert">{{errorText}}</v-alert>
    <div class="d-flex">
      
      <div class="d-flex flex-column">
        
        <h1>Company</h1>
        <v-text-field class="flex-grow-0" label="Company name" v-model="company.organizationName"></v-text-field>
        <v-text-field class="flex-grow-0" label="Company code" v-model="company.organizationCode"></v-text-field>
        <v-text-field
          class="flex-grow-0"
          label="username"
          v-model="company.username"
          :error-messages="companyUserNameErrors"
        ></v-text-field>
        <v-text-field
          class="flex-grow-0"
          label="password"
          v-model="company.password"
          :error-messages="companyPasswordErrors"
          type="password"
        ></v-text-field>
        <v-text-field
          class="flex-grow-0"
          label="confirm password"
          v-model="company.confirmPassword"
          :error-messages="companyConfirmPasswordErrors"
          type="password"
        ></v-text-field>
        <v-text-field
          class="flex-grow-0"
          label="email"
          v-model="company.email"
          :error-messages="companyEmailErrors"
        ></v-text-field>
      </div>
      <div class="d-flex flex-column ml-12">
        <h1>Front Desk</h1>
        <v-text-field
          class="flex-grow-0"
          label="username"
          v-model="front.username"
          :error-messages="frontUserNameErrors"
        ></v-text-field>
        <v-text-field
          class="flex-grow-0"
          label="password"
          v-model="front.password"
          :error-messages="frontPasswordErrors"
          type="password"
        ></v-text-field>
        <v-text-field
          class="flex-grow-0"
          label="confirm password"
          v-model="front.confirmPassword"
          :error-messages="frontConfirmPasswordErrors"
          type="password"
        ></v-text-field>
        <v-text-field
          class="flex-grow-0"
          label="email"
          v-model="front.email"
          :error-messages="frontEmailErrors"
        ></v-text-field>
      </div>
    </div>
    <v-btn type="submit" class="buttonText mt-5" width="100" tile depressed color="primary">Save</v-btn>
  </v-form>
</template>

<script>
import axios from "axios";
import { required, email, sameAs, minLength } from "vuelidate/lib/validators";
export default {
  created() {
    axios.get(`${process.env.VUE_APP_BASE_URL}/role/`).then(res => {
      this.roles = res.data;
      //userName, userId-null, userPassword, email, active=true
    });

    axios.get(`${process.env.VUE_APP_BASE_URL}/org/`).then(res => {
      console.log(res);
    });
  },

  data() {
    return {
      alert:false,
      errorText:'', 

      roles: [],

      company: {
        organizationName: "",
        organizationCode: "",
        username: "",
        password: "",
        confirmPassword: "",
        email: ""
      },

      front: {
        username: "",
        password: "",
        confirmPassword: "",
        email: ""
      }
    };
  },

  methods: {
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const company = {
          userId: null,
          userName: this.company.username,
          userPassword: this.company.password,
          email: this.company.email,
          active: true
        };

        const front = {
          userId: null,
          userName: this.front.username,
          userPassword: this.front.password,
          email: this.front.email,
          active: true
        };

        let companyId;
        let frontId;
        let organizationId;

        axios
          .post(`${process.env.VUE_APP_BASE_URL}/org/`, {
            organizationId: null,
            organizationName: this.company.organizationName,
            organizationCode: this.company.organizationCode
          })
          .then(res => {
            organizationId = res.data.organizationId;
            return axios.post(`${process.env.VUE_APP_BASE_URL}/user/`, company);
          })
          .then(res => {
            console.log(res);
            companyId = res.data.userId;
            return axios.get(
              `${process.env.VUE_APP_BASE_URL}/user/${companyId}/roleadd/4`
            );
          })
          .then(res => {
            return axios.post(`${process.env.VUE_APP_BASE_URL}/user/`, front);
          })
          .then(res => {
            frontId = res.data.userId;
            return axios.get(
              `${process.env.VUE_APP_BASE_URL}/user/${frontId}/roleadd/2`
            );
          })
          .then(() => {
            return axios.get(
              `${process.env.VUE_APP_BASE_URL}/user/${frontId}/orgadd/${organizationId}`
            );
          })
          .then(res => {
            return axios.get(
              `${process.env.VUE_APP_BASE_URL}/user/${companyId}/orgadd/${organizationId}`
            );
          })
          .then(() => {
            this.$router.push('dashboard')
          })
          .catch(err => {
            this.errorText = err.response.data.error
            this.alert = true
            console.log(err.response);
          });
      }
    }
  },

  validations: {
    company: {
      username: { required },
      password: { required, minLength: minLength(8) },
      confirmPassword: { required, sameAs: sameAs("password") },
      email: { required, email }
    },

    front: {
      username: { required },
      password: { required, minLength: minLength(8) },
      confirmPassword: { required, sameAs: sameAs("password") },
      email: { required, email }
    }
  },

  computed: {
    companyUserNameErrors() {
      const errors = [];
      if (!this.$v.company.username.$dirty) return errors;
      if (!this.$v.company.username.required) errors.push("Required");
      return errors;
    },
    companyPasswordErrors() {
      const errors = [];
      if (!this.$v.company.password.$dirty) return errors;
      if (!this.$v.company.password.required) errors.push("Required");
      if (!this.$v.company.password.minLength)
        errors.push("Must be at least 8 characters");
      return errors;
    },
    companyConfirmPasswordErrors() {
      const errors = [];
      if (!this.$v.company.confirmPassword.$dirty) return errors;
      if (!this.$v.company.confirmPassword.required) errors.push("Required");
      if (!this.$v.company.confirmPassword.sameAs)
        errors.push("Must be same as password");
      return errors;
    },
    companyEmailErrors() {
      const errors = [];
      if (!this.$v.company.email.$dirty) return errors;
      if (!this.$v.company.email.required) errors.push("Required");
      if (!this.$v.company.email.email) errors.push("Invalid email");
      return errors;
    },

    frontUserNameErrors() {
      const errors = [];
      if (!this.$v.front.username.$dirty) return errors;
      if (!this.$v.front.username.required) errors.push("Required");
      return errors;
    },
    frontPasswordErrors() {
      const errors = [];
      if (!this.$v.front.password.$dirty) return errors;
      if (!this.$v.front.password.required) errors.push("Required");
      if (!this.$v.front.password.minLength)
        errors.push("Must be at least 8 characters");
      return errors;
    },
    frontConfirmPasswordErrors() {
      const errors = [];
      if (!this.$v.front.confirmPassword.$dirty) return errors;
      if (!this.$v.front.confirmPassword.required) errors.push("Required");
      if (!this.$v.front.confirmPassword.sameAs)
        errors.push("Must be same as password");
      return errors;
    },
    frontEmailErrors() {
      const errors = [];
      if (!this.$v.front.email.$dirty) return errors;
      if (!this.$v.front.email.required) errors.push("Required");
      if (!this.$v.front.email.email) errors.push("Invalid email");
      return errors;
    }
  }
};
</script>